import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { List, Typography, Grid, Anchor } from 'components/base';
import { CloudinaryPicture } from 'components/rich';
import useDataContext from 'data/context/data';
import BaseNav from 'components/layout/nav';
import Icon, { ICON_TYPE } from 'components/icon';

import { NAV_CATEGORIES } from '../../specifications/lists';
import { ProductDetailLink, CategoryPageLink, ShopPageLink } from '../pageLinks';

const Nav = props => {
  const dataContext = useDataContext();

  const categories = dataContext.getCategories(NAV_CATEGORIES);

  return (
    <BaseNav topPosition={props.topPosition} expanded={props.expanded}>
      <List className="navbar-nav">
        <List.Item className="nav-item">
          <ShopPageLink>
            <Anchor className="nav-link">Everything</Anchor>
          </ShopPageLink>
        </List.Item>

        {categories.map(category => (
          <NavItem key={category.id} category={category} />
        ))}
      </List>
    </BaseNav>
  );
};

Nav.propTypes = {
  topPosition: PropTypes.number,
  expanded: PropTypes.bool,
};

const NavItem = ({ category }) => {
  const hasChild = category.data.length > 0;

  const className = classNames({
    'nav-link': true,
    'nav-link-has-child': hasChild,
  });

  return (
    <BaseNav.Item
      hasChild={hasChild}
      link={
        <CategoryPageLink category={category}>
          <Anchor className={className}>
            {/* {category.id === 'gifts' && (
              <>
                <Icon
                  type={ICON_TYPE.GIFT}
                  className="text-black"
                  size={16}
                  style={{ marginTop: -3 }}
                />{' '}
              </>
            )} */}
            {category.name}
            {/* {category.id === 'cards' && (
              <>
                {' '}
                <Icon
                  type={ICON_TYPE.NEW}
                  className="text-success"
                  size={26}
                  style={{ marginTop: -3 }}
                />
              </>
            )} */}
          </Anchor>
        </CategoryPageLink>
      }
    >
      {hasChild && (
        <Grid.Row>
          {category.data.map(item => {
            const subCategories = item.subCategories.map(subCategory => (
              <CategoryPageLink key={subCategory.id} category={subCategory}>
                <Anchor className="header-product">
                  <CloudinaryPicture imageKey={subCategory.image} type="small" />

                  <div>
                    <Typography.H4>
                      <Typography.Span>{subCategory.name}</Typography.Span>
                    </Typography.H4>
                    <Typography.P className="small">{subCategory.shortDescription}</Typography.P>
                  </div>
                </Anchor>
              </CategoryPageLink>
            ));

            const products = item.products.map(product => (
              <ProductDetailLink key={product.id} productId={product.id}>
                <Anchor className="header-product">
                  <CloudinaryPicture prefix="products/" imageKey={product.images[0]} type="small" />
                  <div>
                    <Typography.H4>
                      <Typography.Span>{product.name}</Typography.Span>
                    </Typography.H4>
                    <Typography.P className="small">{product.shortDescription}</Typography.P>
                  </div>
                </Anchor>
              </ProductDetailLink>
            ));

            return (
              <React.Fragment key={item.key}>
                <Grid.Col xs={12} lg={12}>
                  {item.productsFirst ? (
                    <>
                      {products}
                      {subCategories}
                    </>
                  ) : (
                    <>
                      {subCategories}
                      {products}
                    </>
                  )}
                </Grid.Col>
              </React.Fragment>
            );
          })}
        </Grid.Row>
      )}
    </BaseNav.Item>
  );
};

NavItem.propTypes = {
  category: PropTypes.object.isRequired,
};

export default Nav;
